import { advantages } from '@/mocks/data';

export default function AdvantagesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">
            Fineco Isı Pompası Neden Tercih Ediliyor?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Fineco Isı Pompaları; yüksek verim, güçlü teknoloji ve modern tasarımı bir araya getirerek yaşam alanları için yeni nesil iklimlendirme çözümü sunar.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {advantages.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg p-6 border border-background-200/70 hover:border-primary-200/50 transition-colors group"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}